import api, { MetadataView } from 'api'
import AppDialog from 'components/AppDialog'
import React from 'react'

import { ViewTable } from './components/ViewTable'

interface Props {
	mode: number
	afterSave?: () => void
	metadataView: MetadataView
	systemCode?: string
}
// 新建视图
export default class DataViewFormPage extends React.Component<Props> {
	addView = () => {
		let formData = {} as any
		console.log('formData', formData)
		if (formData) {
			AppDialog.open(
				<ViewTable
					systemCode={this.props.systemCode}
					displayName={formData.displayName}
					name={formData.name}
				/>,
				{
					size: 'full',
				}
			)
		}
	}

	api: any
	render() {
		let formData = this.props.metadataView
		return (
			<div className="app-dialog-form-container">
				{/* <div className="app-dialog-form">
          <AppForm
            formStyle={{ width: '100%' }}
            ref={this.refForm}
            defaultData={formData}
          >
            <AppInput
              label="表中文名"
              field="displayName"
              placeholder="请输入表中文名"
              value = {formData.displayName}
              req
            />
            <AppInput
              label="表英文名"
              field="name"
              placeholder="请输入表英文名"
              value = {formData.name}
              tips="新增表,添加系统_前缀"
              req
            />
          </AppForm>
        </div>
        <AppFormMenu>
          <AppAction
            title="开始设计表"
            type="primary"
            action={this.addView}
          />
        </AppFormMenu> */}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/DataViewFormPage.tsx